import { render, staticRenderFns } from "./time-ranges-select.vue?vue&type=template&id=1276f4ea&scoped=true&"
import script from "./time-ranges-select.vue?vue&type=script&lang=ts&"
export * from "./time-ranges-select.vue?vue&type=script&lang=ts&"
import style0 from "./time-ranges-select.vue?vue&type=style&index=0&id=1276f4ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1276f4ea",
  null
  
)

export default component.exports